(ns superadmin.users.details.grant-columns
  (:require [clojure.string :as str]))

(def  grant-columns
  #js [#js {:field "role-name"
            :headerName "Role"
            :type "string"
            :width 150
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:role-name row))}
       #js {:field "scope-type"
            :headerName "Type"
            :type "string"
            :width 100
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (str/capitalize (:scope-type row)))}
       #js {:field "scope-name"
            :headerName "Name"
            :type "string"
            :minWidth 200
            :flex 2
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (let [scope (:scope row)
                                 scope-type (:scope-type row)]
                             (cond
                               (= scope-type "advertiser")
                               (let [advertiser-name (get-in scope [:advertiser :name])
                                     agency-name (get-in scope [:agency :name])]
                                 (if agency-name
                                   (str agency-name ": " advertiser-name)
                                   advertiser-name))
                               (= scope-type "agency")
                               (get-in scope [:agency :name])
                               :else nil)))}
       #js {:field "scope-id"
            :headerName "ID"
            :type "string"
            :minWidth 100
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (str (:scope-id row)))}])